import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type GlobalSearchPipelineItemsQueryVariables = Types.Exact<{
   params: Types.SearchPipelineItemsParams
}>

export type GlobalSearchPipelineItemsQuery = {
   __typename?: 'Query'
   searchPipelineItems:
      | {
           __typename?: 'FieldIdsNotInPipeline'
           message?: string | null
           fieldIds: Array<string>
           pipelineId: string
        }
      | {
           __typename?: 'FieldsAreDeleted'
           message?: string | null
           fieldIds: Array<string>
        }
      | {
           __typename?: 'FieldsNotFound'
           message?: string | null
           fieldIds: Array<string>
        }
      | { __typename?: 'InvalidLimit'; message?: string | null }
      | { __typename?: 'InvalidOffset'; message?: string | null }
      | {
           __typename?: 'NotAllowedFieldsForGlobalSearch'
           message?: string | null
           fieldIds: Array<string>
        }
      | {
           __typename?: 'NotSupportedSalesTemplateFields'
           message?: string | null
           fieldIds: Array<string>
           salesTemplateTypes: Array<Types.SalesTemplateType>
        }
      | { __typename?: 'PaginationLimitExceeded'; message?: string | null }
      | {
           __typename?: 'PipelineAccessDenied'
           message?: string | null
           pipelineId: string
           name: string
        }
      | { __typename?: 'PipelineItemTemplateAccessDenied' }
      | { __typename?: 'PipelineItemTemplateNotFound'; message?: string | null }
      | {
           __typename?: 'PipelineNotFound'
           message?: string | null
           pipelineId: string
        }
      | {
           __typename?: 'SearchPipelineItemsResult'
           totalCount: number
           pipelineItems: Array<{
              __typename?: 'SearchPipelineItemPrimaryDetails'
              pipelineItemId: string
              name?: string | null
              stage?: {
                 __typename?: 'Stage'
                 stageId: string
                 name: string
                 color?: Types.ColorEnum | null
              } | null
           }>
        }
      | { __typename?: 'SearchQueryIsRequired'; message?: string | null }
}

export const GlobalSearchPipelineItemsDocument = gql`
   query globalSearchPipelineItems($params: SearchPipelineItemsParams!) {
      searchPipelineItems(params: $params) {
         ... on SearchPipelineItemsResult {
            pipelineItems {
               pipelineItemId
               name
               stage {
                  stageId
                  name
                  color
               }
            }
            totalCount
         }
         ... on InvalidOffset {
            message
         }
         ... on InvalidLimit {
            message
         }
         ... on PaginationLimitExceeded {
            message
         }
         ... on NotAllowedFieldsForGlobalSearch {
            message
            fieldIds
         }
         ... on SearchQueryIsRequired {
            message
         }
         ... on PipelineNotFound {
            message
            pipelineId
         }
         ... on PipelineAccessDenied {
            message
            pipelineId
            name
         }
         ... on FieldsNotFound {
            message
            fieldIds
         }
         ... on FieldsAreDeleted {
            message
            fieldIds
         }
         ... on NotSupportedSalesTemplateFields {
            message
            fieldIds
            salesTemplateTypes
         }
         ... on FieldIdsNotInPipeline {
            message
            fieldIds
            pipelineId
         }
         ... on PipelineItemTemplateNotFound {
            message
         }
      }
   }
`
export type GlobalSearchPipelineItemsQueryResult = Apollo.QueryResult<
   GlobalSearchPipelineItemsQuery,
   GlobalSearchPipelineItemsQueryVariables
>
